import DemoForm from '../DemoForm';
import '../../styles/quiet-invitation.css';

export default function Hero() {
  return <section id="home" className="qi-hero" aria-label="AI และระบบอัตโนมัติสำหรับงาน">
    <img className="qi-plate-bg" src={`${import.meta.env.BASE_URL}plates/automatehq-sunny-hero.png`} alt="" aria-hidden="true" />
    <div className="qi-shell">
      <div className="qi-split">
        <div className="qi-copy">
          <h1 className="qi-headline">AI ระบบอัตโนมัติ และแอปที่ช่วยแบ่งเบา<span>งานของคุณ</span></h1>
          <p className="qi-subhead">เราเชื่อมเครื่องมือที่คุณใช้ ทำงานซ้ำให้เป็นระบบอัตโนมัติ และสร้างแอปขนาดเล็กสำหรับงานที่สเปรดชีตจัดการไม่ไหว ตั้งแต่ติดตามลูกค้าไปจนถึงประมวลผลเอกสาร เราเปลี่ยนขั้นตอนที่ทำด้วยมือให้เป็นระบบที่ใช้งานได้จริง</p>
          <a className="studio-text-link" href="#services">ดูสิ่งที่เราช่วยได้ <span aria-hidden="true">↘</span></a>
          <div className="qi-hero-note"><span className="qi-note-mark" aria-hidden="true">↳</span><p>เราเริ่มจากทำความเข้าใจวิธีทำงานของทีม แล้วออกแบบระบบเพื่อแก้งานที่เป็นปัญหา</p></div>
        </div>
        <div className="qi-form-card" id="request-demo">
          <div className="qi-form-title"><span className="qi-form-intro">เริ่มต้นง่าย ๆ</span><h2>มาคุยเรื่อง<br className="form-title-break" />เวิร์กโฟลว์ของคุณ</h2><p>ส่งรายละเอียดสั้น ๆ แล้วผมจะติดต่อกลับด้วยตัวเอง เพื่อเข้าใจสิ่งที่คุณต้องการและนัดเดโมที่เกี่ยวข้อง</p></div>
          <DemoForm locale="th" />
        </div>
      </div>
    </div>
  </section>;
}
